import React, {Component} from 'react';
import {Factory} from './components/factory';
import Dashboard from './components/mobile/dashboard';
import {connect} from 'react-redux';

class CorrelationStackedTeamsList extends Component {
    canComponentBeRendered() {
        const {comboGroups} = this.props;

        return comboGroups.hasAnyGroups();
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {sportConfig} = this.props;
        const StackedTeamsList = Factory.getComponent(sportConfig);

        return (
            <div className="tab-content stack-combinations-content">
                <Dashboard />
                {StackedTeamsList ? <StackedTeamsList /> : null}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        correlationStacking: {combinations},
    } = state;

    return {
        sportConfig,
        comboGroups: combinations.groups,
    };
}

const CorrelationStackedTeamsListComponent = connect(mapStatesToProps)(CorrelationStackedTeamsList);

export {CorrelationStackedTeamsListComponent};
